export default "__VITE_ASSET__DH0dKS3X__"